import { SVGProps, Ref, forwardRef } from 'react';

export const PinOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m18.651 8.572-5.495 5.493.416 2.91a4.32 4.32 0 0 1-1.037 3.468l-8.983-8.981a4.32 4.32 0 0 1 3.469-1.037l2.91.416 5.495-5.493zM13.81 21.717a6.12 6.12 0 0 0 1.544-4.997l-.288-2.019 4.858-4.857 1.803 1.803L23 10.374 13.623 1 12.35 2.272l1.803 1.803-4.858 4.857-2.02-.288a6.12 6.12 0 0 0-4.998 1.544c-.442.404-.853.845-1.277 1.268l5.14 5.138-5.136 5.134L2.276 23l5.136-5.134 5.129 5.128c.424-.424.864-.835 1.269-1.277"
            fill="currentColor"
        />
    </svg>
));
PinOutlinedSize24Glyph.displayName = 'PinOutlinedSize24Glyph';
